import { render } from "./siteSetting.vue?vue&type=template&id=c2820a04&scoped=true"
import script from "./siteSetting.vue?vue&type=script&lang=js"
export * from "./siteSetting.vue?vue&type=script&lang=js"

import "./siteSetting.vue?vue&type=style&index=0&id=c2820a04&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2820a04"]])

export default __exports__